import { Col, Row } from "react-bootstrap";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../shared/oversight-core/ui-elements/modal-container/modal-container";

interface IProps extends ModelContainerProps {
  show: boolean;
}
const RemoveWaterHeaterSystemModal = (props: IProps) => {
  const { show, ...rest } = props;

  return (
    <ModalContainer
      {...rest}
      title="Are you sure you want to Remove the Water Heater System?"
      show={show}
      size="modal-lg"
      confirmButtonText="Remove"
      confirmButtonVariant="red"
    >
      <Row>
        <Col className="text-color-2 font-weight-500 font-size-14">
          This action cannot be undone. Removing Water Heater System will
          permanently remove it from your estimation. Any associated data in
          system will be lost.
        </Col>
      </Row>
    </ModalContainer>
  );
};

export default RemoveWaterHeaterSystemModal;
